import React from "react";
import { useAtomValue } from "jotai";
import { unlockState, settingState } from "@stores/modal";
import { bgmState } from "@stores/bookdata";
import UnLock from "./UnLock";
import Settings from "./Settings";

const PopupContainer = () => {
  const unlock = useAtomValue(unlockState);
  const settingInfo = useAtomValue(settingState);
  if (unlock.show === true) {
    return <UnLock />;
  }
  if (settingInfo.show) {
    return <Settings />;
  }
  return null;
};

export default PopupContainer;
